import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDatewithNullCheck } from '../../../utils/formatting';
import { RouteComponentProps } from 'react-router-dom';
import {getValueOrDefault} from '../../../utils/NullCheck/index';

interface EICRCardProps extends RouteComponentProps<any> {
  EICRPropsData: any;
}

const EICRCard: React.FC<EICRCardProps> = ({ EICRPropsData }) => {
  const { t } = useTranslation();
  return (
    <div className="body-card row m-0 border-terracotta display-column">
      <h4>{t("EICRCard")}</h4>
      <div className="eicr-card mt-4 p-0">
          <div className='record-repair justify-between pb-16'><h6>{t("Due_Date")}</h6>
            <p>{formatDatewithNullCheck(EICRPropsData?.visitDue)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Contractor")}</h6>
            <p>{getValueOrDefault(EICRPropsData?.contractor?.contractorName)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Contractor_Contact")}</h6>
            <p>{getValueOrDefault(EICRPropsData?.contractor?.contractorNumber)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Last_Visit")}</h6>
            <p>{formatDatewithNullCheck(EICRPropsData?.visitActual)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Visit_Outcome")}</h6>
            <p>{getValueOrDefault(EICRPropsData?.visitOutcome)}</p></div>
      </div>
    </div>
  );
};

export default EICRCard;